import dayjs from 'dayjs';

export const dateFilters = {
  toDateFormatWithSlash(value: string): string {
    if (value == null || value === '') return '';
    return dayjs(value).format('YYYY/MM/DD');
  },
  toDateTimeFormat(value: string): string {
    if (value == null || value === '') return '';
    return dayjs(value).format('YYYY-MM-DD HH:mm');
  },
  toMonthFormat(value: string): string {
    if (value == null || value === '') return '';
    return dayjs(value).format('YYYY-MM');
  },
  toDayjsFormat(value: string, format: string): string {
    if (value == null || value === '') return '';
    return dayjs(value).format(format);
  }
};

type StartAndEndDate = {
  year: number | null;
  month: number | null;
};

export const startAndEndDateFilters = {
  /**
   * toDate
   *
   * @param startAndEndDate StartAndEndDate
   * @returns dayjs.Dayjs | null
   */
  toDayjs(startAndEndDate: StartAndEndDate): dayjs.Dayjs | null {
    if (startAndEndDate.year === null || startAndEndDate.month === null) {
      return null;
    }

    return dayjs(`${startAndEndDate.year}-${startAndEndDate.month}-01`);
  },
  /**
   * toPeriodFromStartAndDate
   * 開始年月と終了年月から期間を計算する
   * 計算結果は「y年mヶ月」もしくは「mヶ月」と表示する
   *
   * @param startAt number | null
   * @param endAt number | null
   * @returns string | null
   */
  toPeriodFromStartAndDate(
    startAt: number | null,
    endAt: number | null
  ): string | null {
    // 開始年月が設定されていない場合は計算しない
    if (startAt === null) {
      return null;
    }

    // Dateへ変換
    const toDate = (startAndEndDate: number): Date => {
      const year = String(startAndEndDate).substring(0, 4);
      const month = Number(String(startAndEndDate).substring(4, 6));
      return new Date(`${year}-${month}-01`);
    };

    const startAtDate: Date = toDate(startAt);
    // 終了年月がnullの場合は、現在日時を使用
    const endAtDate: Date = endAt ? toDate(endAt) : new Date();
    // 計算結果が1ヶ月間マイナスとなるため、終了年月には+1ヶ月をする
    endAtDate.setMonth(endAtDate.getMonth() + 1);

    const timeStamp = Number(endAtDate) - Number(startAtDate);
    let elapsedDay = Math.floor(timeStamp / 86400000);
    const elapsedYear = Math.floor(elapsedDay / 365);
    elapsedDay -= elapsedYear * 365;
    const elapsedMonth = Math.floor(elapsedDay / 30);

    // 計算結果が0未満になった場合は計算結果を返さない
    if (elapsedYear < 0 || elapsedMonth < 0) {
      return null;
    }

    // 働いていた期間を計算
    return elapsedYear === 0
      ? `${elapsedMonth}ヶ月`
      : `${elapsedYear}年${elapsedMonth}ヶ月`;
  },
  /**
   * isBefore
   * - 開始年月・終了年月が選択されていない場合は、falseを返す
   * - 開始年月(2022/04)が終了年月(2022/05)より前の場合は、falseを返す
   * - 開始年月(2022/05)が終了年月(2022/04)より後の場合は、trueを返す
   *
   * @param startAt StartAndEndDate
   * @param endAt StartAndEndDate
   * @returns boolean
   */
  isBefore(startAt: StartAndEndDate, endAt: StartAndEndDate): boolean {
    const startDate = this.toDayjs(startAt);
    const endDate = this.toDayjs(endAt);

    if (startDate === null || endDate === null) {
      return false;
    }

    return endDate.isBefore(startDate);
  }
};
